import { useQuery } from '@tanstack/react-query';
import { getEstimationsByIds } from '@/lib/api/work-integrations/estimations';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';

export const useGetEstimationsByIds = ({
  estimationIds,
  staleTime,
  enabled = true,
}: {
  estimationIds: Set<number>;
  staleTime?: number;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: workIntegrationsQueryKeys.estimations.byIds(estimationIds),
    queryFn: () => getEstimationsByIds(estimationIds),
    enabled: enabled && estimationIds.size > 0,
    placeholderData: (previousData) => previousData,
    ...(staleTime !== undefined && { staleTime }),
  });
};
